const Joi = require("joi");

const limitSchema = (InmateInvitePublicCount) => {
  const schema = Joi.object({
    InmateInvitePublicCount: Joi.number()
      .max(100) // Ensures the number is ≤ 100
      .required()
      .messages({
        "number.base": "Please enter Limit.",
        "number.max": "Please enter a value lesser than or equal to 100.",
        "any.required": "Please enter Limit.",
      }),
  }).unknown(true);

  return schema.validate({ InmateInvitePublicCount }, { abortEarly: false });
};

module.exports = limitSchema;
